import type { NavigatorWithStorageBuckets } from './StorageBucket';

export function areStorageBucketsAvailable(): boolean {
    const nav = navigator as NavigatorWithStorageBuckets;
    return typeof nav.storageBuckets?.open === 'function';
}
